import React from 'react';
import Question from './Question';
import ScrollToTop from './ScrollToTop';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

const QAPage = ({ skills, evaluation, onNext, onPrev, category, page, inputChange }) => {
  const renderQuestions = () => {
    const questions = skills[category];
    const titles = skills[category+"-titles"];
    return questions.map((question, index) => (
      <Question key={index} number={index} question={question} category={category} title={titles[index]} evaluation={evaluation} inputChange={inputChange} currentValue={evaluation[titles[index]]} />
    ));
  };

  return (
    <ScrollToTop>
      <Box display="flex" padding={2} justifyContent="center">
        <section>
          <h2 className="question-h2">{category} Skills ( {page}/4 )</h2>
          <hr></hr>
          {renderQuestions()}
          <br></br>
          <hr></hr>
          <br></br>
          <Box display="flex" paddingTop={0} paddingBottom={3} justifyContent="center">
            <Button onClick={onPrev}>Previous</Button>
            <Button onClick={onNext}>Next</Button>
          </Box>
        </section>
      </Box>
    </ScrollToTop>
  );
};

export default QAPage;
